(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-dropdown-account"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // -----------------------------
  // Cookie Helpers
  // -----------------------------
  function setCookies(name, value, days) {
      const maxAge = days * 24 * 60 * 60; // convert days to seconds
      document.cookie = `${name}=${value}; Domain=.westside.com; path=/; max-age=${maxAge}`;
  }

  function getCookies(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';')[0];
      return null;
  }

  // const regionSelect = document.getElementById("regionSelect");

  const dropdown = document.querySelector('.custom-dropdowns');
  console.log('dropdown !!',dropdown);

  if (!dropdown) return;

  const select = document.getElementById('CountrySwitchSelect');
  const options = dropdown.querySelectorAll('.dropdown-optionss li');
  const selected = dropdown.querySelector('.selected');

  // Toggle dropdown
  dropdown.addEventListener('click', function() {
    console.log('btn clicked !! at dropdown !!');

    const ul = dropdown.querySelector('.dropdown-optionss');
    ul.style.display = ul.style.display === 'block' ? 'none' : 'block';
  });

  // Option click
  document.querySelector('.dropdown-optionss').addEventListener('click', function(e) {
    const option = e.target.closest('li');
    if (!option) return;
    const value = option.getAttribute('data-value');
    setCookies('selected_region', value, 1);
    if (value === "india") {
        window.location.href = "https://www.westside.com";
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target)) {
      const ul = dropdown.querySelector('.dropdown-optionss');
      ul.style.display = 'none';
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const drawerMenu = document.querySelector('.drawer-menu'); // your drawer container
  const dropdown = document.querySelector('.custom-dropdowns'); // your country dropdown
  if (!drawerMenu || !dropdown) return;

  const options = dropdown.querySelectorAll('.dropdown-optionss li');
  const checkmarks = dropdown.querySelectorAll('.checkmark svg polyline');

  // Function to update dropdown colors based on drawer state
  function updateDropdownColor() {
    const isOpen = drawerMenu.classList.contains('drawer-opened'); // adjust class name
    
    if (isOpen) {
      dropdown.style.color = 'red';
      dropdown.style.borderColor = 'red';
      options.forEach(li => li.style.color = 'red');
      checkmarks.forEach(svg => svg.setAttribute('stroke', 'red'));
    } else {
      dropdown.style.color = '';
      dropdown.style.borderColor = '';
      options.forEach(li => li.style.color = '');
      checkmarks.forEach(svg => svg.setAttribute('stroke', ''));
    }
  }

  // Listen to hover (mouseenter/mouseleave) on dropdown
  dropdown.addEventListener('mouseenter', function() {
    dropdown.querySelector('.dropdown-optionss').style.display = 'block';
    console.log('opened !!')
    updateDropdownColor();
  });

  dropdown.addEventListener('mouseleave', function() {
    dropdown.querySelector('.dropdown-optionss').style.display = 'none';
    console.log('leaved !!')
    updateDropdownColor(); // optional: revert color if drawer closed
  });

  // Optional: detect drawer class changes via MutationObserver
  const observer = new MutationObserver(updateDropdownColor);
  observer.observe(drawerMenu, { attributes: true, attributeFilter: ['class'] });
});



document.addEventListener('DOMContentLoaded', function () {
  const navMenu = document.querySelector('.header__inline-menu');
  const countrySwitch = document.querySelector('.country-switch-dropdowns');

  if (!navMenu || !countrySwitch) return;

  // Remember original state
  const isOriginallyHomepage = countrySwitch.classList.contains('homepage');

  navMenu.addEventListener('mouseenter', () => {
    // Remove homepage styles on hover
    countrySwitch.classList.remove('homepage');
  });

  navMenu.addEventListener('mouseleave', () => {
    // Restore homepage styles only if it was originally homepage
    if (isOriginallyHomepage) {
      countrySwitch.classList.add('homepage');
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // -----------------------------
  // Cookie Helpers
  // -----------------------------
  function setCookies(name, value, days) {
      const maxAge = days * 24 * 60 * 60; // convert days to seconds
      document.cookie = `${name}=${value}; Domain=.westside.com; path=/; max-age=${maxAge}`;
  }

  function getCookies(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';')[0];
      return null;
  }

  // const regionSelect = document.getElementById("regionSelect");

  const dropdown = document.querySelector('.custom-dropdown');
  console.log('dropdown !!',dropdown);

  if (!dropdown) return;

  const select = document.getElementById('CountrySwitchSelect');
  const options = dropdown.querySelectorAll('.dropdown-options li');
  const selected = dropdown.querySelector('.selected');

  // Toggle dropdown
  dropdown.addEventListener('click', function() {
    console.log('btn clicked !! at dropdown !!');

    const ul = dropdown.querySelector('.dropdown-options');
    ul.style.display = ul.style.display === 'block' ? 'none' : 'block';
  });

  // Option click
  document.querySelector('.dropdown-options').addEventListener('click', function(e) {
    const option = e.target.closest('li');
    if (!option) return;
    const value = option.getAttribute('data-value');
    setCookies('selected_region', value, 1);
    if (value === "india") {
        window.location.href = "https://www.westside.com";
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target)) {
      const ul = dropdown.querySelector('.dropdown-options');
      ul.style.display = 'none';
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const drawerMenu = document.querySelector('.drawer-menu'); // your drawer container
  const dropdown = document.querySelector('.custom-dropdown'); // your country dropdown
  if (!drawerMenu || !dropdown) return;

  const options = dropdown.querySelectorAll('.dropdown-options li');
  const checkmarks = dropdown.querySelectorAll('.checkmark svg polyline');

  // Function to update dropdown colors based on drawer state
  function updateDropdownColor() {
    const isOpen = drawerMenu.classList.contains('drawer-opened'); // adjust class name
    
    if (isOpen) {
      dropdown.style.color = 'red';
      dropdown.style.borderColor = 'red';
      options.forEach(li => li.style.color = 'red');
      checkmarks.forEach(svg => svg.setAttribute('stroke', 'red'));
    } else {
      dropdown.style.color = '';
      dropdown.style.borderColor = '';
      options.forEach(li => li.style.color = '');
      checkmarks.forEach(svg => svg.setAttribute('stroke', ''));
    }
  }

  // Listen to hover (mouseenter/mouseleave) on dropdown
  dropdown.addEventListener('mouseenter', function() {
    dropdown.querySelector('.dropdown-options').style.display = 'block';
    console.log('opened !!')
    updateDropdownColor();
  });

  dropdown.addEventListener('mouseleave', function() {
    dropdown.querySelector('.dropdown-options').style.display = 'none';
    console.log('leaved !!')
    updateDropdownColor(); // optional: revert color if drawer closed
  });

  // Optional: detect drawer class changes via MutationObserver
  const observer = new MutationObserver(updateDropdownColor);
  observer.observe(drawerMenu, { attributes: true, attributeFilter: ['class'] });
});



document.addEventListener('DOMContentLoaded', function () {
  const navMenu = document.querySelector('.header__inline-menu');
  const countrySwitch = document.querySelector('.country-switch-dropdown');

  if (!navMenu || !countrySwitch) return;

  // Remember original state
  const isOriginallyHomepage = countrySwitch.classList.contains('homepage');

  navMenu.addEventListener('mouseenter', () => {
    // Remove homepage styles on hover
    countrySwitch.classList.remove('homepage');
  });

  navMenu.addEventListener('mouseleave', () => {
    // Restore homepage styles only if it was originally homepage
    if (isOriginallyHomepage) {
      countrySwitch.classList.add('homepage');
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["detect-country"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', async () => {
      var detected = await detectCountryUsingShopifyApi();

      console.log(detected);
      const form = document.getElementById('HeaderCountryForm');
      const countryInput = form?.querySelector('input[name="country_code"]');
      const gccCountries = ['SA', 'AE', 'QA', 'OM', 'BH'];
      // if (window.localStorage.getItem(storageKey) !== 'true') {

      // } else
      // console.log(window.localStorage.getItem(storageKey) !== 'true' && form && countryInput && countryInput.value != detected.code + "JJJJJ");
      if (
        window.localStorage.getItem(storageKey) !== 'true' &&
        form &&
        countryInput &&
        countryInput.value != detected.code &&
        gccCountries.includes(detected.code)
      ) {
        countryInput.value = detected.code;
        form.submit();
      }
      var storageKey = 'gcc-country-prompt-dismissed';
      var container = document.querySelector('.gcc-country-prompt');
      if (!container) return;

      var dialog = container.querySelector('.gcc-country-prompt__dialog');
      if (!dialog) return;

      if (container.getAttribute('data-show-dialog') === 'true') {
        if (typeof dialog.showModal === 'function' && window.localStorage.getItem(storageKey) !== 'true') {
          //  if (gccCountries.includes(detected.code)) {
          dialog.showModal();
          //  }
          //  else {
          //   const noCountryPanel = document.querySelector('[data-panel="nocountry"]');
          //   console.log(noCountryPanel);
          //   if (noCountryPanel) {
          //     var panels = dialog.querySelectorAll('.gcc-country-prompt__panel');
          //     // console.log(panels);
          //     panels.forEach(function (panel) {
          //       var panelName = panel.getAttribute('data-panel');
          //       console.log(panelName);
          //       var isTarget = panelName === 'nocountry';
          //       if (isTarget && window.localStorage.getItem(storageKey) !== 'true') {
          //         panel.removeAttribute('hidden');
          //       } else {
          //         panel.setAttribute('hidden', '');
          //       }
          //     });
          //   }
          //   dialog.showModal();
          //  }
        }
      }

      function showPanel(name) {
        var panels = dialog.querySelectorAll('.gcc-country-prompt__panel');
        // console.log(panels);
        panels.forEach(function (panel) {
          var panelName = panel.getAttribute('data-panel');
          console.log(panelName);
          var isTarget = panelName === name;
          if (isTarget && window.localStorage.getItem(storageKey) !== 'true') {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          dialog.close();
        }
      });

      /* ===== Country option: click handler (works for already-checked too) ===== */
      dialog.addEventListener('click', function (event) {
        var countryOption = event.target.closest('.gcc-selector__country-option');
        if (!countryOption) return;

        var radio = countryOption.querySelector('.gcc-selector__country-radio');
        if (!radio) return;

        var selectedValue = radio.value;

        if (selectedValue === 'IN') {
          window.location.href = 'https://www.westside.com';
          return;
        }

        /* If it's the same country that's already active, just close */
        var currentCountry = container.getAttribute('data-current-country');
        if (selectedValue === currentCountry) {
          window.localStorage.setItem(storageKey, 'true');
          dialog.close();
          return;
        }

        /* Different country — select it and submit the form */
        radio.checked = true;
        var localizationForm = dialog.querySelector('#localization_form');
        if (localizationForm) {
          localizationForm.submit();
        }
      });

      dialog.addEventListener('click', function (event) {
        var actionEl = event.target.closest('[data-action]');
        if (!actionEl) return;

        var actionName = actionEl.getAttribute('data-action');
        var currentCountry = container.getAttribute('data-current-country');
        if (actionName === 'accept-country' || actionName === 'close-dialog') {
          if (!gccCountries.includes(currentCountry)) {
            window.location.href = 'https://www.westside.com';
          } else {
            window.localStorage.setItem(storageKey, 'true');
            dialog.close();
          }
        }

        if (actionName === 'change-country') {
          showPanel('selector');
        }

        if (actionName === 'back-to-question') {
          showPanel('question');
        }

        if (actionName === 'changed-country') {
          var localizationForm = dialog.querySelector('#localization_form');
          var selectedCountry = localizationForm.querySelector('input[name="country_code"]:checked');
          console.log(selectedCountry.value);

          if (selectedCountry && selectedCountry.value === 'IN') {
            window.location.href = 'https://www.westside.com';
            return;
          } else {
            localizationForm.submit();
          }
        }
      });

      var menudialog = document.querySelector('.shipping-location-header');
      console.log('HELLOoooo');
      console.log(menudialog);
      menudialog.addEventListener('click', function (event) {
        console.log(menudialog);
        var actionEl = event.target.closest('.gcc-country-prompt__button');
        if (!actionEl) return;
        var actionName = actionEl.getAttribute('data-action');
        console.log(actionName);
        if (actionName === 'change-country') {
          // showPanel('selector');
          var panels = dialog.querySelectorAll('.gcc-country-prompt__panel');
          console.log(panels);
          panels.forEach(function (panel) {
            console.log(panel);
            var panelName = panel.getAttribute('data-panel');
            var isTarget = panelName === 'selector';
            if (isTarget) {
              dialog.style.display = 'block';
              panel.removeAttribute('hidden');
            } else {
              dialog.style.display = 'none';
              panel.setAttribute('hidden', '');
            }
          });
        }
      });

      var footerDropDown = document.querySelector('.custom-dropdown');
      if (footerDropDown) {
        footerDropDown.addEventListener('click', function (event) {
          var actionEl = event.target.closest('.gcc-country-prompt__button');
          if (!actionEl) return;
          var actionName = actionEl.getAttribute('data-action');
          if (actionName === 'change-country') {
            // First unhide the selector panel and hide others
            var panels = dialog.querySelectorAll('.gcc-country-prompt__panel');
            panels.forEach(function (panel) {
              var panelName = panel.getAttribute('data-panel');
              if (panelName === 'selector') {
                panel.removeAttribute('hidden');
              } else {
                panel.setAttribute('hidden', '');
              }
            });
            // Then open the dialog properly
            if (!dialog.open) {
              dialog.showModal();
            }
          }
        });
      }
      /* ===== QUICKFIX: Track footer/header open and clean up ===== */
      var openedExternally = false;

      if (footerDropDown) {
        footerDropDown.addEventListener('click', function () {
          openedExternally = true;
        });
      }

      if (menudialog) {
        menudialog.addEventListener('click', function () {
          openedExternally = true;
        });
      }

      dialog.addEventListener('click', function (event) {
        var actionEl = event.target.closest('[data-action="back-to-question"]');
        if (actionEl && openedExternally) {
          event.stopImmediatePropagation();
          openedExternally = false;
          dialog.close();
          dialog.style.display = 'none';
          setTimeout(function () {
            dialog.style.display = '';
          }, 0);
        }
      });

      dialog.addEventListener('close', function () {
        if (openedExternally) {
          openedExternally = false;
          dialog.style.display = 'none';
          setTimeout(function () {
            dialog.style.display = '';
          }, 0);
        }
      });
    });

    async function detectCountryUsingShopifyApi() {
      const response = await fetch(
        window.Shopify.routes.root +
          'browsing_context_suggestions.json' +
          '?country[enabled]=true' +
          `&country[exclude]=${window.Shopify.country}` +
          '&language[enabled]=true' +
          `&language[exclude]=${window.Shopify.language}`
      );

      // const response = await fetch(url);
      console.log('hellllloooo' + response);
      if (!response.ok) return null;

      const data = await response.json();
      console.log('hellllloooo2' + data);
      if (data.detected_values && data.detected_values.country) {
        return {
          code: data.detected_values.country.handle,
          name: data.detected_values.country.name,
        };
      }

      if (Array.isArray(data.suggestions) && data.suggestions.length > 0) {
        const parts = data.suggestions[0].parts;
        if (parts && parts.country) {
          return {
            code: parts.country.handle,
            name: parts.country.name,
          };
        }
      }

      return null;
    }
  } catch(e) { console.error(e); }
})();

})();
